import React, { Component } from "react";
import "./styles.css";

export default class Home extends Component {
  componentDidMount() {
    document.getElementsByTagName("chatbot")[0].style.display = "none";
    window.location.href = "https://exa.com.br";
  }
  render() {
    return <></>;
  }
}
